import styles from './SpyRunError.module.css'
import { useState } from 'react';
import { DateTime } from 'luxon';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

type SpyRunErrorProps = {
    notificationLog: any,
    loading?: boolean,
}

export const SpyRunError = (props: SpyRunErrorProps): JSX.Element => {
    const {
        notificationLog,
        loading = false
    } = props;
    const [notification, setNotification] = useState<any | null>(null);

    useEffect(() => {
        if (notificationLog === undefined) {
            return
        }

        const data: any = JSON.parse(notificationLog.data);

        const message = `Spy run error`;

        const notification = {
            title: `Spy run error!`,
            date: DateTime.fromISO(notificationLog.dateTimeUtc).toFormat('M/dd/yyyy'),
            time: DateTime.fromISO(notificationLog.dateTimeUtc).toFormat('hh:mm a'),
            message: message,
            data: data,
        }

        setNotification(notification);
    }, [
        notificationLog
    ])

    if (notification === null) {
        return (<></>)
    }

    return (
        <div
            className={styles.SpyLaunchFinishedNotification__Link}
            //to={`/spy/${notification.data.MonitorId}/monitorrun`}
        >
            <div className={styles.SpyLaunchFinishedNotification}>
                <div
                    className={styles.SpyLaunchFinishedNotification__Header}
                >
                    <div className={styles.SpyLaunchFinishedNotification__Heading1}>
                        {notification.title}
                    </div>
                    <div className={styles.SpyLaunchFinishedNotification__DateTimeContainer}>
                        <div className={styles.SpyLaunchFinishedNotification__Date}>
                            {notification.date}
                        </div>
                        <div className={styles.SpyLaunchFinishedNotification__Time}>
                            {notification.time}
                        </div>
                    </div>
                </div>
                <hr className={styles.SpyLaunchFinishedNotification__HeaderDivider}></hr>
                <div>
                    <div className={styles.SpyLaunchFinishedNotification__Message}>
                        {notification.message}
                    </div>
                </div>
                <div className={styles.SpyLaunchFinishedNotification__SeeMoreContainer}>
                    <div className={styles.SpyLaunchFinishedNotification__SeeMore}>
                        {/* See more */}
                    </div>
                </div>
            </div>
        </div>
    )
}
